<template>
    <div class="duels-filter-count" v-bind:class="{ 'count-open': duelsDropdown === true }">
        <button v-on:click="duelsToggleDropdown" class="button-toggle">
            <IconUserGradient />
            {{duelsFilterCount}}
            <IconDropdown />
        </button>
        <div class="count-menu">
            <div class="menu-inner">
                <button v-on:click="duelsSetValue(2)">2</button>
                <button v-on:click="duelsSetValue(3)">3</button>
                <button v-on:click="duelsSetValue(4)">4</button>
                <button v-on:click="duelsSetValue(5)">5</button>
                <button v-on:click="duelsSetValue(6)">6</button>
                <button v-on:click="duelsSetValue(7)">7</button>
                <button v-on:click="duelsSetValue(8)">8</button>
                <button v-on:click="duelsSetValue(9)">9</button>
                <button v-on:click="duelsSetValue(10)">10</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import IconUserGradient from '@/components/icons/IconUserGradient';
    import IconDropdown from '@/components/icons/IconDropdown';

    export default {
        name: 'DuelsFilterCount',
        components: {
            IconUserGradient,
            IconDropdown
        },
        data() {
            return {
                duelsDropdown: false
            }
        },
        methods: {
             ...mapActions([
                'duelsSetFilterCount'
            ]),
            duelsToggleDropdown() {
                this.duelsDropdown = !this.duelsDropdown;
            },
            duelsSetValue(value) {
                this.duelsSetFilterCount(value);
                this.duelsDropdown = false;
            }
        },
        computed: {
            ...mapGetters([
                'duelsFilterCount'
            ])
        },
        created() {
            let self = this;
            document.addEventListener('click', function(event) {
                if(!self.$el.contains(event.target) && self.duelsDropdown == true) {
                    self.duelsToggleDropdown();
                }
            });
        }
    }
</script>

<style scoped>
    .duels-filter-count {
        position: relative;
        margin-right: 25px;
    }

    .duels-filter-count button.button-toggle {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 14px;
        border-radius: 10px;
        background: linear-gradient(135deg, rgba(26, 26, 26, 0.6) 0%, rgba(13, 13, 13, 0.8) 100%);
        border: 1px solid rgba(184, 115, 51, 0.3);
        font-family: 'Space Grotesk', monospace;
        font-size: 16px;
        font-weight: 700;
        color: #ffffff;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }

    .duels-filter-count button.button-toggle:hover {
        background: linear-gradient(135deg, rgba(26, 26, 26, 0.8) 0%, rgba(13, 13, 13, 0.9) 100%);
        border-color: rgba(184, 115, 51, 0.5);
        box-shadow: 0 4px 12px rgba(184, 115, 51, 0.15);
    }

    .duels-filter-count button.button-toggle svg:first-of-type {
        filter: drop-shadow(0 0 4px rgba(184, 115, 51, 0.3));
    }

    .duels-filter-count button.button-toggle svg:last-of-type {
        width: 10px;
        fill: rgba(184, 115, 51, 0.8);
        transition: all 0.3s ease;
    }

    .duels-filter-count.count-open button.button-toggle svg:last-of-type {
         transform: rotate(180deg);
    }

    .duels-filter-count .count-menu {
        width: 90px;
        height: 0;
        position: absolute;
        top: 27px;
        right: -5px;
        padding: 0 10px;
        transition: height 0.2s ease;
        overflow: hidden;
        z-index: 1;
    }

    .duels-filter-count.count-open .count-menu {
       height: 400px;
       padding: 0 10px 10px 10px;
    }

    .duels-filter-count .menu-inner {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 10px;
        border-radius: 12px;
        background: linear-gradient(135deg, rgba(26, 26, 26, 0.95) 0%, rgba(13, 13, 13, 0.98) 100%);
        border: 1px solid rgba(184, 115, 51, 0.3);
        box-shadow: 
            0 8px 32px rgba(0, 0, 0, 0.5),
            inset 0 1px 0 rgba(255, 255, 255, 0.05);
        backdrop-filter: blur(10px);
    }

    .duels-filter-count .menu-inner::before {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        top: -8px;
        right: 10px;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid rgba(184, 115, 51, 0.3);
    }

    .duels-filter-count .menu-inner::after {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        top: -7px;
        right: 11px;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 7px solid rgba(13, 13, 13, 0.98);
    }

    .duels-filter-count .menu-inner button {
        width: 100%;
        height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 15px;
        font-family: 'Satoshi', sans-serif;
        font-size: 13px;
        font-weight: 700;
        color: rgba(184, 115, 51, 0.7);
        border-bottom: 1px solid rgba(184, 115, 51, 0.15);
        transition: all 0.3s ease;
    }

    .duels-filter-count .menu-inner button:first-of-type {
        border-radius: 12px 12px 0 0;
    }

    .duels-filter-count .menu-inner button:last-of-type {
        border-radius: 0 0 12px 12px;
        border-bottom: none;
    }

    .duels-filter-count .menu-inner button:hover {
        color: #ffffff;
        background: rgba(184, 115, 51, 0.1);
        text-shadow: 0 0 10px rgba(184, 115, 51, 0.3);
    }

    @media only screen and (max-width: 768px) {
        .duels-filter-count {
            display: none;
        }
    }

    @media only screen and (max-width: 650px) {

        .duels-filter-count {
            margin-right: 0;
        }

    }
</style>
